export const plans = [
    {
        id: 1,
        name: 'الباقة الاقتصادية',
        price: '1999',
        unit: 'جنيه / متر',
        description: 'تشطيب متميز بسعر اقتصادي يناسب الميزانيات المحدودة',
        features: [
            ' سلك السويدي المعتمد شامل الأسلاك ',
            'سباكة الشريف او (B.R) - ضمان مدى الحياة',
            'عزل أرضيات الحمامات - ضمان مدى الحياة',
            'ديكورات بجميع الالوان',
            'ترميم محارة',
            'مصيص لكامل للشقة',
            'نقاشه فاخرة (سايبس - دايتون - بكين)',
            'سيراميك فرز اول (كليوباترا - ارت - انوفا - رويال)',
        ],
        notIncluded: [
            'الأثاث',
            'الأجهزة الكهربائية',
            'الديكورات الخاصة',
            'التكييف المركزي'
        ],
        recommended: false,
        color: '#3498db'
    },
    {
        id: 2,
        name: 'الباقة هاي لوكس',
        price: '3500',
        unit: 'جنيه / متر',
        description: 'فخامة وتشطيب فاخر بأعلى الخامات والتفاصيل الدقيقة',
        features: [
            'الكهرباء بتأسيس سلك السويدي المعتمد شامل الأسلاك والخرطيم والدش',
            'سباكة الشريف او (B.R) - ضمان مدى الحياة',
            'عزل أرضيات الحمامات - ضمان مدى الحياة',
            'ديكورات بجميع الالوان',
            'ترميم محارة',
            'مصيص لكامل للشقة',
            'نقاشه فاخرة (سايبس - دايتون - بكين)',
            'سيراميك فرز اول (كليوباترا - ارت - انوفا - رويال)',
            'الوميتال B.S ضد الصوت و الاتربه',
            'ابواب غرف فاخرة من معارض الشركة',
            'كرانيش او فيوتك لكامل الشقه',
            'توريد وتركيب طقم صحي وخلاطات في حدود 15000 جنيه (ديورافيت  او ايديال ستاندرد)',
            'توريد وتركيب باب مصفح تركي 11 سم',
            'توريد وتركيب جبس بورد في الريسبشن والطرقات'
        ],
        notIncluded: [
            'الأثاث',
            'الأجهزة الكهربائية'
        ],
        recommended: true,
        color: '#9b59b6'
    },
    {
        id: 3,
        name: 'الباقة اللوكس',
        price: '2850',
        unit: 'جنيه / متر',
        description: 'توازن مثالي بين الجودة العالية والسعر المناسب',
        features: [
            'الكهرباء بتأسيس سلك السويدي المعتمد شامل الأسلاك والخرطيم والدش',
            'سباكة الشريف او (B.R) - ضمان مدى الحياة',
            'عزل أرضيات الحمامات - ضمان مدى الحياة',
            'ديكورات بجميع الالوان',
            'ترميم محارة',
            'مصيص لكامل للشقة',
            'نقاشه فاخرة (سايبس - دايتون - بكين)',
            'سيراميك فرز اول (كليوباترا - ارت - انوفا - رويال)',
            'الوميتال B.S ضد الصوت و الاتربه',
            'ابواب غرف فاخرة من معارض الشركة',
            'كرانيش او فيوتك لكامل الشقه',
            'توريد وتركيب طقم صحي وخلاطات في حدود 1000 جنيه'
        ],
        notIncluded: [
            'الأثاث',
            'الأجهزة الكهربائية المتطورة',
            'التكييف المركزي'
        ],
        recommended: false,
        color: '#e67e22'
    },
];